import * as React from 'react'
import * as styles from './style/index.scss'
import { FormattedMessage } from 'react-intl'
import { enumToView, filterFlowUnit, formatDate, tranlatorTpCycleDayToMth } from '@src/utils';
import intl from '@utils/intl';
import { ComponentExt } from '@utils/reactExt'
import download_icon from '@assets/img/download.png'

class OrderItem extends ComponentExt<any, any> {
    constructor(props) {
        super(props)
        this.state = {
            isDown: ''
        }
    }
    renderFieldValue = (dto, fieldName) => {
        const { timeUnit } = tranlatorTpCycleDayToMth({
            timeUnit: String(dto.timeUnit),
            timeLength: String(dto.timeLength),
            goodsNumber: String(dto.goodsNumber)
        })
        switch (fieldName) {
            case 'content':
                return `${filterFlowUnit(dto.policyDegree)}/${intl.formatMessage({ id: timeUnit === '0' ? 'common.unitMonthOdd' : 'common.unitDayOdd' })} * ${dto.goodsNumber}${intl.formatMessage({ id: timeUnit === '0' ? `common.${dto.goodsNumber === 1 ? 'unitMonthOdd' : 'unitMonthPlural'}` : `common.${dto.goodsNumber === 1 ? 'unitDayOdd' : 'unitDayPlural'}` })}`
            case 'orderSubType':
                return <FormattedMessage id={`order.subType.${dto.orderSubType}`} />
            case 'validity':
                return `${formatDate(dto.createStartTime)} - ${formatDate(dto.createEndTime)} UTC`
            case 'subTotal':
                return `${enumToView('CURRENCY', dto.cargoType)}${Number(dto.salePrice) / 100}`
            case 'vatPrice':
                return `${enumToView('CURRENCY', dto.cargoType)}${dto.vatPrice || 0}`
            case 'totalFee':
                return `${enumToView('CURRENCY', dto.cargoType)}${Number(dto.totalFee) / 100}`
        }
    }
    downloadCallback = () => {
        (window as any).androidDownloadCallback = (result) => {
            this.setState({
                isDown: String(result)
            })
        }
    }
    fileByPath = () => {
        (window as any).JavaInterface.viewFileByPath();
    }
    btnDownload = (val) => {
        if (localStorage.getItem('chl') === 'tabletApp') {
            const objStr = {
                reqType: 'GET',
                url: `https://${window.location.host}/order/invoice/${val.orderId}.pdf`,
                fileName: `${val.orderId}.pdf`
            };
            try {
                this.downloadCallback();
                (window as any).JavaInterface.downloadFile(JSON.stringify(objStr));
            } catch (e) {
                this.$toast.info(e)
            }
        } else {
            window.open(`https://${window.location.host}/order/invoice/${val.orderId}.pdf`)
        }
    }
    render() {
        const { dto, fieldList } = this.props
        return (
            <div>
                <section className={styles.orderItemWrap}>
                    <div className={styles.orderNumWrap}><>
                        <FormattedMessage id="order.item.orderNum" />: {dto.orderId}</>
                        {/*{dto.paymentType === '4' && <div className={styles.btndownload} onClick={() => this.btnDownload(dto)}> <img src={download_icon} alt="" /><span>Download invoice</span></div>}*/}
                    </div>
                    <div className={styles.fieldWrap}>
                        {
                            fieldList.map(fieldItem => (
                                <div className={styles.orderFieldItem} key={fieldItem.messageId}>
                                    <span className={styles.fieldKey}>
                                        <FormattedMessage id={fieldItem.messageId} />
                                    </span>
                                    <span className={styles.fieldValue}>{this.renderFieldValue(dto, fieldItem.fieldName)}</span>
                                </div>
                            ))
                        }
                    </div>
                </section >
                <div className={styles.orderTime}>
                    {`${formatDate(dto.createTime, 'time').time} ${formatDate(dto.createTime, 'time').date} UTC`}
                </div>
                {
                    this.state.isDown === '1' &&
                    <div className={styles.downtotal}>
                        <span>Download files to File Android/data/com.len.pro/files/file</span>
                        <span className={styles.btn} onClick={this.fileByPath}>Clink jump</span>
                    </div>}
            </div >
        )
    }
}

export default OrderItem
